import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { pageHead, publicRow } from "@/lib/route-head";
const FoundingCityLanding = lazy(() => import("@/pages/FoundingCityLanding"));

type F500Meta = { seo_title: string | null; seo_description: string | null; hero_image_url: string | null };

export const Route = createFileRoute("/founding-500/$slug")({
  loader: ({ params }) =>
    publicRow<F500Meta>(
      `founding500_city_pages?select=seo_title,seo_description,hero_image_url&slug=eq.${encodeURIComponent(params.slug)}`,
    ),
  head: ({ params, loaderData }) =>
    pageHead({
      path: `/founding-500/${params.slug}`,
      title: loaderData?.seo_title || "Founding 500 | Amorette",
      description: loaderData?.seo_description || "Join the free Amorette Founding 500 waitlist — curated dinners for real connection.",
      image: loaderData?.hero_image_url,
    }),
  component: FoundingCityLanding,
});
